import { environment } from 'src/environments/environment';

export const PATH_SUPPORT = {
  whats: `${environment.baseAssetsUrl}/repositorio/v3/static/get-sim/whatsapp.svg`,
  phone: `${environment.baseAssetsUrl}/repositorio/v3/static/get-sim/phone.svg`,
};

export const PATH_STORES = {
  walmart: `${environment.baseAssetsUrl}/repositorio/v3/static/stores/walmart.svg`,
  bodega_aurrera: `${environment.baseAssetsUrl}/repositorio/v3/static/stores/bodega_aurrera.svg`,
  sams_club: `${environment.baseAssetsUrl}/repositorio/v3/static/stores/sams_club.svg`,
  walmart_express: `${environment.baseAssetsUrl}/repositorio/v3/static/stores/walmart_express.svg`,
  bodega_despensa: `${environment.baseAssetsUrl}/repositorio/v3/static/stores/despensa_casa.svg`,
  cashi: `${environment.baseAssetsUrl}/repositorio/v3/static/stores/cashi.svg`,
  GOOGLE: `${environment.baseAssetsUrl}/repositorio/v3/static/stores/google.svg`,
  APPLE: `${environment.baseAssetsUrl}/repositorio/v3/static/stores/apple.svg`,
};

export const LOGO_LOADER: string = './assets/icons/loader/bait-loader.gif';

export const PLANES = {
  planOne: '../../../assets/images/postpaid/planes/pospago_160.webp',
  planTwo: '../../../assets/images/postpaid/planes/pospago_210.webp',
  planThree: '../../../assets/images/postpaid/planes/pospago_290.webp',
};

export const IMG_BILLING = {
  validateNumber: {
    alt: 'Validar número',
    img: '/assets/images/postpaid/billing/validar-numero.webp',
  },
  invoiceSummary: {
    alt: 'Resumen de factura',
    img: '/assets/images/postpaid/billing/resumen-pago.webp',
  },
  warning: {
    alt: 'warning icon',
    img: '/assets/icons/icon-warning.svg',
  },
  warningCircle: {
    alt: 'warning icon',
    img: '/assets/images/postpaid/img-icons/icono-warning-circle.webp',
  },
  success: {
    alt: 'success icon',
    img: '/assets/images/postpaid/img-icons/icono-success.webp',
  },
  error: {
    alt: 'error icon',
    img: '/assets/images/postpaid/img-icons/icono-error.webp',
  },
};

export const ARROW_UP = './assets/icons/arrow-up.svg';

export const PATH_LINK_RECHARGE = '/recargas';

export const IMG_POSPAID = {
  NUMBER_VALIDATION: {
    alt: 'Validación numero',
    img: '/assets/images/postpaid/pospago-steps/validacion_numero_fondo.webp',
  },
  CAPTURE_DATA: {
    alt: 'Informacion de CLiente',
    img: '/assets/images/postpaid/pospago-steps/fondo_ingresa_datos.webp',
  },
  SIGN_CONTRACT: {
    alt: 'Firma contrato',
    img: '/assets/images/postpaid/pospago-steps/fondo_contrato.webp',
  },
  COMPATIBILITY: {
    PORTABILITY: {
      alt: 'Portabilidad',
      img: 'assets/images/postpaid/pospago-steps/phone-compatibility-porta.webp',
    },
    NEW_MIGRATION: {
      alt: 'Nuevo, Migración',
      img: 'assets/images/postpaid/pospago-steps/phone-compatibility.webp',
    },
  },
  PAYMENTS: {
    PAYMENT_CONFIRM: {
      alt: 'Pago confirmado',
      img: '/assets/images/postpaid/pospago-steps/recibo-pago.webp',
    },
    ONLINE_PAYMENT: {
      alt: 'Pago en Linea',
      img: '/assets/images/postpaid/pospago-steps/pago_en_linea.webp',
    },
  },
  ESIM_DESCRIPTION: {
    alt: 'Descripción esim',
    img: '../../../assets/images/postpaid/img-icons/cuestion.webp',
  },
};

export const HOME_STORES = [
  {
    url: 'https://www.bodegaaurrera.com.mx/',
    image: PATH_STORES.bodega_aurrera,
    alt: 'Bodega Aurrera',
    title: 'Se abrirá en otra pestaña',
  },
  {
    url: 'https://www.sams.com.mx',
    image: PATH_STORES.sams_club,
    alt: 'Sams Club',
    title: 'Se abrirá en otra pestaña',
  },
  {
    url: 'https://www.walmart.com.mx/',
    image: PATH_STORES.walmart,
    alt: 'Walmart',
    title: 'Se abrirá en otra pestaña',
  },
  {
    url: 'https://www.superama.com.mx/',
    image: PATH_STORES.walmart_express,
    alt: 'Walmart Express',
    title: 'Se abrirá en otra pestaña',
  },
];
